import { render, staticRenderFns } from "./EnableTwoFactorAuthentication.vue?vue&type=template&id=f0ec0428&scoped=true"
import script from "./EnableTwoFactorAuthentication.vue?vue&type=script&lang=js"
export * from "./EnableTwoFactorAuthentication.vue?vue&type=script&lang=js"
import style0 from "./EnableTwoFactorAuthentication.vue?vue&type=style&index=0&id=f0ec0428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ec0428",
  null
  
)

export default component.exports